import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    preview_img: [],
    event_status: null,
    creator_list: [],
    national_year_list: [],
    customer_name: [],
    news_status: null,
    category_status: null,
    morning_status: null
  },
  mutations: {},
  actions: {},
  modules: {}
});
